const objectionTrackerActions = {
GET_OBJECTION_QUESTION_DETAILS : 'GET_OBJECTION_QUESTION_DETAILS',
SET_OBJECTION_QUESTION_DETAILS : 'SET_OBJECTION_QUESTION_DETAILS',
GET_OBJECTION_QUESTION_DETAILS_COUNT : 'GET_OBJECTION_QUESTION_DETAILS_COUNT',
SET_OBJECTION_QUESTION_DETAILS_COUNT : 'SET_OBJECTION_QUESTION_DETAILS_COUNT',
UPDATE_OBJECTION_QUESTION_DETAILS : 'UPDATE_OBJECTION_QUESTION_DETAILS',

INITIALIZE_REFUND : 'INITIALIZE_REFUND',

GET_REFUND_STATUS : 'GET_REFUND_STATUS',
SET_REFUND_STATUS : 'SET_REFUND_STATUS',

};
export default objectionTrackerActions;
